import { render } from "./ScrollText.vue?vue&type=template&id=039c8c7f&scoped=true"
import script from "./ScrollText.vue?vue&type=script&lang=js"
export * from "./ScrollText.vue?vue&type=script&lang=js"

import "./ScrollText.vue?vue&type=style&index=0&id=039c8c7f&lang=scss&scoped=true"

import exportComponent from "/Applications/XAMPP/xamppfiles/htdocs/studioemme/wp-content/themes/studioemme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-039c8c7f"]])

export default __exports__